import React, { useState, useEffect } from 'react';

function OfertaFlashBadge({ oferta, size = 'normal' }) {
  const [tiempoRestante, setTiempoRestante] = useState({});
  const [expirada, setExpirada] = useState(false);

  useEffect(() => {
    const calcularTiempo = () => {
      const ahora = new Date().getTime();
      const fin = new Date(oferta.fecha_fin).getTime();
      const diff = fin - ahora;

      if (diff <= 0) {
        setExpirada(true);
        return;
      }

      setTiempoRestante({
        dias: Math.floor(diff / (1000 * 60 * 60 * 24)),
        horas: Math.floor((diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)),
        minutos: Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60)),
        segundos: Math.floor((diff % (1000 * 60)) / 1000)
      });
    };

    calcularTiempo();
    const interval = setInterval(calcularTiempo, 1000);
    return () => clearInterval(interval);
  }, [oferta.fecha_fin]);

  if (expirada) return null;

  const cuposRestantes = oferta.cupos_oferta - oferta.cupos_vendidos;
  if (cuposRestantes <= 0) return null;

  const { dias, horas, minutos, segundos } = tiempoRestante;
  const isLarge = size === 'large';

  return (
    <div
      className={`absolute top-0 right-0 z-10 rounded-bl-lg text-white shadow-lg ${isLarge ? 'px-4 py-3' : 'px-3 py-2'}`}
      style={{ backgroundColor: oferta.color || '#FF4444' }}
    >
      <div className={`flex items-center gap-1 font-bold ${isLarge ? 'text-sm' : 'text-xs'}`}>
        <span>⚡</span>
        <span>{oferta.nombre}</span>
      </div>

      <div className="flex gap-1 text-center mt-1">
        {dias > 0 && (
          <div className="bg-black/20 rounded px-1.5 py-0.5">
            <div className={`font-bold leading-none ${isLarge ? 'text-base' : 'text-sm'}`}>{dias}</div>
            <div className="text-[9px] opacity-80">días</div>
          </div>
        )}
        <div className="bg-black/20 rounded px-1.5 py-0.5">
          <div className={`font-bold leading-none ${isLarge ? 'text-base' : 'text-sm'}`}>{String(horas).padStart(2, '0')}</div>
          <div className="text-[9px] opacity-80">hrs</div>
        </div>
        <div className="bg-black/20 rounded px-1.5 py-0.5">
          <div className={`font-bold leading-none ${isLarge ? 'text-base' : 'text-sm'}`}>{String(minutos).padStart(2, '0')}</div>
          <div className="text-[9px] opacity-80">min</div>
        </div>
        <div className="bg-black/20 rounded px-1.5 py-0.5">
          <div className={`font-bold leading-none ${isLarge ? 'text-base' : 'text-sm'}`}>{String(segundos).padStart(2, '0')}</div>
          <div className="text-[9px] opacity-80">seg</div>
        </div>
      </div>

      <div className="mt-1 text-center">
        <span className={`font-semibold ${isLarge ? 'text-sm' : 'text-xs'}`}>
          ¡Solo {cuposRestantes} cupo{cuposRestantes !== 1 ? 's' : ''}!
        </span>
      </div>

      {isLarge && (
        <div className="mt-2">
          <div className="w-full bg-black/20 rounded-full h-1.5">
            <div
              className="h-1.5 rounded-full bg-white/70 transition-all"
              style={{ width: `${Math.min(100, (oferta.cupos_vendidos / oferta.cupos_oferta) * 100)}%` }}
            />
          </div>
          <div className="text-[9px] opacity-80 text-center mt-0.5">
            {oferta.cupos_vendidos}/{oferta.cupos_oferta} cupos vendidos
          </div>
        </div>
      )}
    </div>
  );
}

export default OfertaFlashBadge;
